<template lang="html">
  <div class="sign-up-study" :class="{'holder': !completed}">
    <img :src="image" alt="" class="img-w" @load="imageLoad()" ref="img">
    <div class="sign-up-study-cover" @click="$emit('click')">
      <img src="../../assets/images/sign-up-study.png" alt="" class="sign-up-study-button">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignUpStudy',
  props: ['image'],
  data () {
    return {
      completed: false
    }
  },
  mounted () {
    this.$refs.img.addEventListener('load', () => {
      setTimeout(() => {
        this.completed = true
      }, 2000)
    })
  },
  methods : {
    imageLoad () {
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.sign-up-study {
  position: relative;
  min-height: rem(400);
  .holder {
    min-height: rem(400);
  }
  &-cover {
    @include afull();
    @include center-box();
    background-color: rgba(0,0,0,.4);
  }
  &-button {
    display: block;
    @include square(240, 70);
  }
}
</style>
